const ACCOUNTS_BASE_URL = '/accounts';
const FRESHWORKS_BASE_URL = `${ACCOUNTS_BASE_URL}/freshworks/v1`;

export const API_URLS = {
    'getTenantAppsUrl': `${ACCOUNTS_BASE_URL}/applications/v3/tenantApps`,
    'getFreshworksAccountsUrl': `${FRESHWORKS_BASE_URL}/accounts`,
    'postFreshworksAccountsUrl': `${FRESHWORKS_BASE_URL}/accounts`,
    'postSyncFreshworksUsersUrl': `${FRESHWORKS_BASE_URL}/sync`
}
